import {z} from 'zod';

/**
 * The backend uses what is called a "label value" pattern in quite a few places.\
 * This is a simple schema to represent that pattern.
 */
export const LabelValueSchema = z.object({
	label: z.string(),
	value: z.string(),
});

/** LabelValue type */
export type ILabelValue = z.infer<typeof LabelValueSchema>;

export default LabelValueSchema;
